
export default {
  name: 'hashtag-animation',
  mixins: [],
  data () {
    return {
      needIntersection: true,
      mobile: true
    }
  },
  props: {
    delay: 0
  },
  mounted () {
    this.mobile = this.$store.state.ua.platform.type !== 'desktop'
    this.$refs.container.dataset.content = this.$refs.container.innerHTML.replace('&amp;', '&')
    this.$el._show = this.show.bind(this)
    this.$el._hide = this.hide.bind(this)
  },
  methods: {
    show () {
      this.$el.classList.remove('up')
      this.$el.classList.remove('down')
    },
    hide (up = true) {
      if (up) {
        this.$el.classList.add('up')
      } else {
        this.$el.classList.add('down')
      }
    }
  }
}
